type Size = 'sm' | 'md';

export default function Heart({
  value,
  size = 'md',
}: {
  value: boolean;
  size?: Size;
}) {
  const sizeClasses = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';

  if (value) {
    return (
      <Container>
        <HeartFilledIcon className={sizeClasses} />
      </Container>
    );
  }
  return (
    <Container>
      <HeartIcon className={sizeClasses} />
    </Container>
  );
}

const Container = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex h-5 w-5 items-center justify-center">{children}</div>
  );
};

export function HeartIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M1.60791 7.67432C1.60791 6.91064 1.72965 6.21338 1.97314 5.58252C2.22217 4.94613 2.56527 4.39827 3.00244 3.93896C3.43962 3.47965 3.9515 3.12549 4.53809 2.87646C5.12467 2.62191 5.75553 2.49463 6.43066 2.49463C7.22201 2.49463 7.92204 2.66341 8.53076 3.00098C9.13949 3.33301 9.62646 3.77295 9.9917 4.3208C10.368 3.77295 10.8577 3.33301 11.4609 3.00098C12.0697 2.66341 12.7697 2.49463 13.561 2.49463C14.2417 2.49463 14.8726 2.62191 15.4536 2.87646C16.0402 3.12549 16.5521 3.47965 16.9893 3.93896C17.4264 4.39827 17.7668 4.94613 18.0103 5.58252C18.2593 6.21338 18.3838 6.91064 18.3838 7.67432C18.3838 8.85303 18.0711 10.0234 17.4458 11.1855C16.8205 12.3477 15.9378 13.4766 14.7979 14.5723C13.6634 15.668 12.3215 16.7139 10.772 17.71C10.6447 17.793 10.5091 17.8677 10.3652 17.9341C10.2269 18.0005 10.1024 18.0337 9.9917 18.0337C9.89209 18.0337 9.77035 18.0005 9.62646 17.9341C9.48258 17.8677 9.34977 17.793 9.22803 17.71C7.67855 16.7139 6.33105 15.668 5.18555 14.5723C4.04557 13.4766 3.16292 12.3477 2.5376 11.1855C1.91781 10.0234 1.60791 8.85303 1.60791 7.67432ZM3.28467 7.66602C3.28467 8.39648 3.45898 9.14079 3.80762 9.89893C4.16178 10.6571 4.64323 11.4069 5.25195 12.1484C5.86068 12.89 6.55794 13.6011 7.34375 14.2817C8.13509 14.9569 8.96794 15.585 9.84229 16.166C9.91976 16.2269 9.96956 16.2573 9.9917 16.2573C10.0138 16.2573 10.0692 16.2269 10.1577 16.166C11.0321 15.585 11.8621 14.9569 12.6479 14.2817C13.4338 13.6011 14.131 12.89 14.7397 12.1484C15.3485 11.4069 15.8271 10.6571 16.1758 9.89893C16.5299 9.14079 16.707 8.39648 16.707 7.66602C16.707 6.96322 16.5659 6.34896 16.2837 5.82324C16.0015 5.29753 15.6141 4.88802 15.1216 4.59473C14.6346 4.2959 14.084 4.14648 13.4697 4.14648C12.9661 4.14648 12.5345 4.23503 12.1748 4.41211C11.8206 4.58366 11.5163 4.80225 11.2617 5.06787C11.0072 5.32796 10.7858 5.58805 10.5977 5.84814C10.4759 6.00863 10.3708 6.12207 10.2822 6.18848C10.1992 6.25488 10.1024 6.28809 9.9917 6.28809C9.88656 6.28809 9.78971 6.25765 9.70117 6.19678C9.61263 6.13037 9.50749 6.01416 9.38574 5.84814C9.21419 5.58252 9.00114 5.31966 8.74658 5.05957C8.49202 4.79948 8.18213 4.58366 7.81689 4.41211C7.45719 4.23503 7.02555 4.14648 6.52197 4.14648C5.90771 4.14648 5.35433 4.2959 4.86182 4.59473C4.37484 4.88802 3.99023 5.29753 3.70801 5.82324C3.42578 6.34896 3.28467 6.96322 3.28467 7.66602Z" />
    </svg>
  );
}

export function HeartFilledIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M9.9917 18.0337C9.89209 18.0337 9.77035 18.0005 9.62646 17.9341C9.48258 17.8677 9.34977 17.793 9.22803 17.71C7.67855 16.7139 6.33105 15.668 5.18555 14.5723C4.04557 13.4766 3.16292 12.3477 2.5376 11.1855C1.91781 10.0234 1.60791 8.85303 1.60791 7.67432C1.60791 6.91064 1.72965 6.21338 1.97314 5.58252C2.22217 4.94613 2.5625 4.39827 2.99414 3.93896C3.43132 3.47965 3.9349 3.12549 4.50488 2.87646C5.0804 2.62191 5.7002 2.49463 6.36426 2.49463C7.1888 2.49463 7.9082 2.70492 8.52246 3.12549C9.13672 3.54606 9.62646 4.09391 9.9917 4.76904C10.368 4.08838 10.8605 3.54053 11.4692 3.12549C12.0835 2.70492 12.8029 2.49463 13.6274 2.49463C14.2915 2.49463 14.9113 2.62191 15.4868 2.87646C16.0623 3.12549 16.5659 3.47965 16.9976 3.93896C17.4292 4.39827 17.7668 4.94613 18.0103 5.58252C18.2593 6.21338 18.3838 6.91064 18.3838 7.67432C18.3838 8.85303 18.0711 10.0234 17.4458 11.1855C16.8205 12.3477 15.9378 13.4766 14.7979 14.5723C13.6634 15.668 12.3215 16.7139 10.772 17.71C10.6447 17.793 10.5091 17.8677 10.3652 17.9341C10.2269 18.0005 10.1024 18.0337 9.9917 18.0337Z" />
    </svg>
  );
}
